/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { AIGenerateBrandedNewIcon } from '@coursera/cds-icons';

import { CoachChat } from 'bundles/ai-coach-platform/components/patterns';
import { ChatEmptyState } from 'bundles/ai-coach-platform/components/patterns/chat/common';
import { usePageHeaderInfoState } from 'bundles/composable-page-header/hooks/usePageHeaderInfoState';
import CourseraAiFooter from 'bundles/unified-common/components/coach-on-discovery/CourseraAiFooter';
import CourseraAiHeader from 'bundles/unified-common/components/coach-on-discovery/CourseraAiHeader';
import CourseraAiMessage from 'bundles/unified-common/components/coach-on-discovery/CourseraAiMessage';
import CourseraAiMessageLoader from 'bundles/unified-common/components/coach-on-discovery/CourseraAiMessageLoader';
import CourseraAiTemporaryStreamedMessage from 'bundles/unified-common/components/coach-on-discovery/CourseraAiTemporaryStreamedMessage';
import FullScreenCoachChatContainer from 'bundles/unified-common/components/coach-on-discovery/FullScreenCoachChatContainer';
import { useGlobalCoachChatState } from 'bundles/unified-common/providers/GlobalCoachChatStateProvider';
import { useNavAiSparkle } from 'bundles/unified-common/providers/NavAiSparkleExperimentProvider';

import _t from 'i18n!nls/unified-common';

const styles = {
  containerAdditionalStyles: css`
    box-shadow: none;
  `,
  coachChatAdditionalStyles: css`
    padding: 0;
  `,
};

const GlobalCoachChat = () => {
  const { showNavAiSparkle } = useNavAiSparkle();
  const { pageChatType, contextConfig } = useGlobalCoachChatState();
  const { height, shouldOffsetHeader, scrollMovementOffset } = usePageHeaderInfoState();
  const topOffset = shouldOffsetHeader ? height - scrollMovementOffset : height;

  if (!showNavAiSparkle || pageChatType !== null) return null;

  return (
    <FullScreenCoachChatContainer topOffset={topOffset} additionalStyles={styles.containerAdditionalStyles}>
      <CoachChat
        additionalStyles={styles.coachChatAdditionalStyles}
        aria-label={_t('Ask Coursera chat')}
        inputLabel={_t('Ask Coursera')}
        chatMessageListAriaLabel={_t('Ask Coursera chat messages')}
        mode={contextConfig.config.coachModeId}
        contextConfig={contextConfig}
        customHeader={
          <CourseraAiHeader
            icon={<AIGenerateBrandedNewIcon size="large" />}
            hideTitle={true}
            closeBtnEventLocation="chat"
          />
        }
        renderCustomMessage={(props) => <CourseraAiMessage {...props} />}
        renderCustomMessageLoader={(props) => <CourseraAiMessageLoader {...props} />}
        renderCustomTemporaryStreamedMessage={(props) => <CourseraAiTemporaryStreamedMessage {...props} />}
        customFooter={<CourseraAiFooter />}
        emptyState={<ChatEmptyState title={_t('Hi there!')} subtitle={_t('How can I help?')} />}
        enableTextStreaming={true}
        enableLoggedOutMode={true}
        storeSessionId={true}
        showSettings={false}
        fetchChatHistoryOnInflightSend={false}
      />
    </FullScreenCoachChatContainer>
  );
};

export default GlobalCoachChat;
